(function() {
    // S: [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선 - 템플릿수정
    var eventItemTemplate =
        '<li class="lists">\n' +
        '    <div class="list-inner">\n' +
        '        <a href="{{url}}" {{#if target === "new"}}target="_blank" {{/if}}>\n' +
        '            <span class="thumb">\n' +
        '                <img src="{{listThumbnailPath}}" alt="{{listThumbnailAltText}}" style="aspect-ratio: 444/317">\n' +
        '            </span>\n' +
        '            <div class="info">\n' +
        '                <span class="tit"><i class="blind">이벤트 제목</i>{{title}}</span>\n' +
        '                <span class="date"><i class="blind">이벤트 기간</i>{{fromDate}}~{{toDate}}</span>\n' +
        '            </div>\n' +
        '        </a>\n' +
        '    </div>\n' +
        '</li>';
    // E: [전시] [BTOCSITE-78612] [전시] [LGE.COM] 렛츠그램 개선

    $(window).ready(function() {
        var event = {
            eventParams: {"page":1},
            init: function() {
                self.$event = $('.gram-event').first();
                self.$tab = self.$event.find('div.ui_tab');
                self.$list = self.$event.find('ul.box-list-inner');
                self.$noData = self.$event.find('div.no-data');
                self.$totalCount = self.$event.find('#totalCount');
                self.$moreBtn = self.$event.find('div.read-more-area button.read-more');
                var _self = this;

                self.gram_event_history_data = 'gram_event_history_data';

                // self.historyData = lgkorUI.getStorage(self.gram_event_history_data);
                _self.bindEvents();
                _self.checkNoData();
                _self.requestData(true);
            },
            bindEvents: function() {
                var _self = this;

                self.$list.on('click', 'div.list-inner a.btn-link', function(e) {
                    e.preventDefault();
                    _self.requestModal(this);
                });

                self.$moreBtn.off("click").on("click", function(e){
                    e.preventDefault();
                    _self.clickBtnMore();
                });

            },
            noData: function(visible) {
                if(visible) {
                    self.$noData.show();
                } else {
                    self.$noData.hide();
                }
            },
            checkNoData: function() {
                var _self = this;
                _self.noData(self.$list.find('li').length > 0 ? false : true);
            },
            requestData: function(isOnLoad) {
                var _self = this;
                var ajaxUrl = self.$event.attr('data-list-url');
                var postData = _self.eventParams;

                if(!isOnLoad) { // 첫 load 시 미실행
                    lgkorUI.setStorage(self.gram_event_history_data, postData, false);
                }

                lgkorUI.requestAjaxDataPost(ajaxUrl, postData, function(result){
                    _self.updateList(result.data);
                });
            },
            updateList: function(data) {
                var _self = this;
                var arr =  data ? (data instanceof Array ? data : []) : [];
                var eventList = (arr.length > 0) ? arr[0].eventList : [];

                // 더보기 버튼, 총 갯수 셋팅
                _self.setPageData(data)
                eventList.forEach(function(item, index) {
                    self.$list.append(vcui.template(eventItemTemplate, item));
                });
                _self.checkNoData();
            },
            setPageData: function(data) {
                var _self = this;
                var pagination = (data.length > 0) ? data[0].pagination : [];
                var listTotalCount = (data.length > 0) ? data[0].listTotalCount : 0;

                // 리스트 총 갯수 셋팅
                self.$totalCount.text('총 '+ vcui.number.addComma(listTotalCount) +'개');

                if (pagination.page < pagination.totalCount) {
                    self.$moreBtn.show();
                } else {
                    self.$moreBtn.hide();
                }
            },
            // 더보기 버튼 클릭시 이벤트
            clickBtnMore: function() {
                var _self = this;
                _self.eventParams.page = parseInt(_self.eventParams.page) + 1;
                _self.requestData();
            }
        };

        event.init();
    });
})();